"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _CopyableLink = require("../CopyableLink/CopyableLink");
var _Link = require("./Link.styled");
var Icon = function Icon(_ref) {
  var icon = _ref.icon,
    screenReaderText = _ref.screenReaderText,
    mode = _ref.mode;
  var iconColor = mode === 'dark' ? '#8D91AF' : '#6E7582';
  return _react["default"].createElement("span", null, _react["default"].createElement(_Link.StyledIcon, {
    color: iconColor,
    icon: icon
  }), _react["default"].createElement("span", {
    className: "visually-hidden"
  }, screenReaderText));
};
var Link = exports.Link = function Link(_ref2) {
  var title = _ref2.title,
    subTitle = _ref2.subTitle,
    shortId = _ref2.shortId,
    onCopy = _ref2.onCopy,
    onCopyStreamLink = _ref2.onCopyStreamLink,
    url = _ref2.url,
    _ref2$mode = _ref2.mode,
    mode = _ref2$mode === void 0 ? 'dark' : _ref2$mode,
    copyDDActionName = _ref2.copyDDActionName,
    openDDActionName = _ref2.openDDActionName;
  var urlToUse = url;
  if (!urlToUse) {
    var location = window.location;
    var baseUrl = "".concat(location.protocol, "//").concat(location.host);
    urlToUse = "".concat(baseUrl, "/streams/").concat(shortId);
  }
  return _react["default"].createElement(_Link.Wrapper, {
    mode: mode,
    className: "link-wrapper"
  }, _react["default"].createElement(_Link.StyledLabel, {
    className: "link-title",
    mode: mode
  }, title), _react["default"].createElement("p", {
    className: "link-sub-title"
  }, subTitle), _react["default"].createElement(_Link.StyledSection, {
    className: "link-footer"
  }, _react["default"].createElement(_CopyableLink.CopyableLink, {
    url: urlToUse,
    onCopy: onCopy
  }, _react["default"].createElement(_Link.StyledInput, {
    mode: mode,
    value: urlToUse,
    disabled: true
  })), _react["default"].createElement(_CopyableLink.CopyableLink, {
    url: urlToUse,
    onCopy: onCopy
  }, _react["default"].createElement(_Link.StyledButton, {
    mode: mode,
    onClick: onCopyStreamLink,
    "data-dd-action-name": copyDDActionName
  }, _react["default"].createElement(Icon, {
    mode: mode,
    screenReaderText: "Copy",
    icon: _freeSolidSvgIcons.faCopy
  }))), _react["default"].createElement(_Link.StyledButton, {
    "data-dd-action-name": openDDActionName,
    mode: mode,
    onClick: function onClick() {
      return window.open(urlToUse, '_blank');
    }
  }, _react["default"].createElement(Icon, {
    mode: mode,
    screenReaderText: "Open in new tab",
    icon: _freeSolidSvgIcons.faExternalLinkAlt
  }))));
};
Link.propTypes = {
  title: _propTypes["default"].string.isRequired,
  subTitle: _propTypes["default"].string,
  shortId: _propTypes["default"].string.isRequired,
  onCopy: _propTypes["default"].func,
  onCopyStreamLink: _propTypes["default"].func,
  mode: _propTypes["default"].oneOf(['light', 'dark']),
  url: _propTypes["default"].string,
  copyDDActionName: _propTypes["default"].string,
  openDDActionName: _propTypes["default"].string
};